export const toCampaignDateISO = (date: Date | string): string => {
  const d = date instanceof Date ? date : new Date(date);
  return d.toISOString();
};

export const parseCampaignDate = (value: Date | string): Date => (value instanceof Date ? value : new Date(value));
